<template>
	<div class='invoice-details'>
    <div>
      <h6 v-if="type.toUpperCase() === 'DEPOSIT'" class='sub-header primary-color'>{{getText('DepositDetails')}}</h6>
      <h6 v-else-if="type.toUpperCase() === 'FINAL'" class='sub-header primary-color'>{{getText('FinalDetails')}}</h6>
      <h6 v-else class='sub-header primary-color'>{{getText('InvoiceDetails')}}</h6>
      <div v-if="type.toUpperCase() === 'DEPOSIT'" class="general-note" style="">{{getText('DepositDetailsHint')}}</div>
      <div v-else-if="type.toUpperCase() === 'FINAL'" class="general-note" style="">{{getText('FinalDetailsHint')}}</div>
      <div v-else class="general-note" style="">{{getText('InvoiceDetailsHint')}}</div>
    </div>
		<!-- First row: Invoice Details -->
		<div class="row">
			<div class="col-sm-6">
				<FormInput :disabled="!invoice_editable.invoice" :title="getText('InvoiceId')" :placeholder="getText('InvoiceIdPlaceholder')" v-model='invoice_id'/>
			</div>
			<div v-if='!invoice.amount_payable' class="col-sm-6" >
				<!-- @TODO: Set prefix to currency symbol & set step value based on selected currency -->
				<div class='merchant-flag'>
					<div class='currency-text'>
						<img v-if="merchant.Country && merchant.Country.length>0" class='flag' :src='"https://st.rch.io/flags/"+merchant.Country+".png"' />
						<span class='flag-text' >{{merchant_currency.currency}}</span>
					</div>
				</div>
				<FormNumber :disabled="!invoice_editable.amount" :title="getText('InvoiceAmount')" :prefix="merchant_currency.symbol" placeholder="100.00" v-model='amount'/>
			</div>
		</div>
		<!-- Second row: Country / Total -->
		<div class="row">
			<div class="col-sm-6 country-block">
				<FormSelect
					:title="getText('YourCurrency')"
					:options="currency_options"
					autocomplete="currency"
					:default_text="getText('SelectCurrency')"
          default_disabled=true
          :disabled="!invoice_editable.payment_currency"
					v-model='currency'
				/>
			</div>

			<div class="col-sm-6">
				<label>{{getText("AmountPayable")}}</label>
				<div class='currency-block'>
					<div class='merchant-flag'>
						<div class='currency-text'>
							<span class='flag-text' v-if='rateOffer.RateOffer !== undefined'>{{rateOffer.Currency}}</span>
						</div>
					</div>

					<div class='currency-text no-flag' v-if='rateOffer.RateOffer !== undefined'>
						{{rateOffer.Symbol}} {{getamountPayable()}}
					</div>
					<div class='ex-rate float-right' v-if='rateOffer.Currency != "" && merchant_currency.currency != rateOffer.Currency'>(1 {{merchant_currency.currency}} = {{rateOffer.RateOffer.Rate}} {{rateOffer.Currency}})</div>
					<div class='currency-text no-flag' v-if='rateOffer.RateOffer === undefined'>
						{{getText('NoExchangeRate')}}
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>

import { mapGetters } from "vuex";
import store from "@/store";

import {
	SET_INVOICE_DATA
} from "@/store/mutations.type";

import FormInput from "@/components/form_elements/FormInput"
import FormNumber from "@/components/form_elements/FormNumber"
import FormSelect from "@/components/form_elements/FormSelect"

// Language / Localization
import LanguageService from "@/common/language.service";

export default {
	name: "InvoiceDetails",
	components: {
		FormInput,
		FormNumber,
		FormSelect
	},
	props: {
		currencies: Array
	},
	data(){
		return {
			invoice_id: '',
			amount: '',
			country: '',
			currency: '',
      type: '',
      amount_payable: '',
		};
	},
	beforeMount(){
		this.invoice_id = this.invoice.id;
		this.amount = this.invoice.amount;
		this.country = this.invoice.payment_country;
		this.currency = this.invoice.payment_currency;
    this.type = this.invoice.type;
    this.amount_payable = this.invoice.amount_payable;

		if (this.invoice.payment_country && !this.invoice.payment_currency) {
      const countryObject = this.countries.find(c => c.code === this.invoice.payment_country);
			this.currency = countryObject.currency;
      this.invoice_editable.payment_currency = true;
		}
    if(this.invoice.payment_currency){
      const countryObject = this.countries.find(c => c.currency === this.invoice.payment_currency);
      if(countryObject){
        this.currency = countryObject.currency;
      }else{
        this.currency = "";
        this.invoice_editable.payment_currency = true;
      }
    }
		store.commit(SET_INVOICE_DATA, this.invoice_details);
	},
	computed: {
		...mapGetters(["merchant", "invoice", "invoice_editable", "rateOffer", "available_countries", "currency_options", "rates", "merchant_currency", "countries"]),
		invoice_details(){
			return {
				'id': this.invoice_id,
				'amount': this.amount,
				'payment_currency': this.currency,
				'payment_country': this.country,
        'type': this.type,
        'amount_payable': this.amount_payable,
			};
		},
	},
	watch: {
		invoice_details(invoice_details){
			store.commit(SET_INVOICE_DATA, invoice_details);
		},
	},
	methods: {
		getText(key){
			return LanguageService.getText(key);
		},
    getamountPayable(){
      let amountPayable;
      if(!this.amount_payable){
        amountPayable = (this.amount * this.rateOffer.RateOffer.Rate).toFixed(this.rateOffer.Units) || "--"
      }else{
        amountPayable = parseFloat(this.amount_payable).toFixed(this.rateOffer.Units);
        this.invoice_editable.amount = false;
        this.amount = (parseFloat(this.amount_payable) / this.rateOffer.RateOffer.Rate).toFixed(this.merchant_currency.units);
      }
      return amountPayable;
    }
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
	.merchant-flag{

		position: absolute;
		right: 25px;
		bottom: 7px;
		z-index: 999;

		.currency-text{
			position: relative;

			.flag{
				left: 0px;
				top:2px;
			}

			.flag-text{
				position: relative;
				top: 2px;
			}
		}
	}
	label{
		width: 100%;
		margin-top: 20px;
		margin-bottom: 5px;
		font-family: 'proximanova-bold';
	}
	.general-note{
		margin-bottom: 10px;
	}
	.flag{
		position: absolute;
		top: 10px;
		height: 24px;
	}
	.currency-block{
		padding: 8px 13px 6px 12px;
		background: rgba(205, 205, 205, 0.4);
		position: relative;
		border-radius: 5px;
		color: #747C84;

		.merchant-flag{
			right: 10px;
		}
	}
	.country-flag{
		position: absolute;
		top: auto;
		right: 10px;
	}
	.currency-text{
		display: inline-block;
		font-size: 20px;
		width: 100%;
		padding-left: 40px;

		&.no-flag{
			padding-left: 0px;
		}
	}
	.ex-rate{
		font-size: 0.7em;
		position: absolute;
		bottom: -18px;
		left: 5px;
	}
	.country-block{
		position: relative;

		.flag{
			top: auto;
			bottom: 12px;
			right: 35px;
		}

	}
</style>
